import { render } from "./BzScreen.vue?vue&type=template&id=255c466a&scoped=true"
import script from "./BzScreen.vue?vue&type=script&lang=js"
export * from "./BzScreen.vue?vue&type=script&lang=js"

import "./BzScreen.vue?vue&type=style&index=0&id=255c466a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255c466a"]])

export default __exports__